webpackJsonp([2],{

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _ButtonSizes = __webpack_require__(52);

var _ButtonSizes2 = _interopRequireDefault(_ButtonSizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var BaseButton = function BaseButton(props) {
  var buttonRef = props.buttonRef,
      buttonType = props.buttonType,
      children = props.children,
      className = props.className,
      icon = props.icon,
      iconPosition = props.iconPosition,
      size = props.size,
      buttonProps = _objectWithoutProperties(props, ['buttonRef', 'buttonType', 'children', 'className', 'icon', 'iconPosition', 'size']);

  var classes = (0, _classnames2.default)('ds-btn-' + buttonType, size, className);
  var LeftIcon = function LeftIcon() {
    return icon && iconPosition === 'left' ? _react2.default.createElement(
      'span',
      { className: 'ds-icon-left' },
      icon
    ) : null;
  };
  var RightIcon = function RightIcon() {
    return icon && iconPosition === 'right' ? _react2.default.createElement(
      'span',
      { className: 'ds-icon-right' },
      icon
    ) : null;
  };
  return _react2.default.createElement(
    'button',
    _extends({
      ref: buttonRef,
      className: classes
    }, buttonProps),
    _react2.default.createElement(LeftIcon, null),
    children,
    _react2.default.createElement(RightIcon, null)
  );
};

BaseButton.defaultProps = {
  buttonRef: null,
  className: '',
  icon: null,
  iconPosition: 'left'
};

// Also accepts all <button /> attributes
BaseButton.propTypes = {
  buttonRef: _propTypes2.default.shape({ current: _propTypes2.default.instanceOf(Element) }),
  buttonType: _propTypes2.default.oneOf(['primary', 'secondary', 'tertiary', 'destructive']).isRequired,
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  icon: _propTypes2.default.node,
  iconPosition: _propTypes2.default.oneOf(['left', 'right']),
  size: _propTypes2.default.oneOf(_ButtonSizes2.default).isRequired
};

exports.default = BaseButton;

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _BaseButton = __webpack_require__(121);

var _BaseButton2 = _interopRequireDefault(_BaseButton);

var _ButtonSizes = __webpack_require__(52);

var _ButtonSizes2 = _interopRequireDefault(_ButtonSizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PrimaryButton = function PrimaryButton(props) {
  var variation = props.variation,
      className = props.className,
      buttonProps = _objectWithoutProperties(props, ['variation', 'className']);

  var classes = (0, _classnames2.default)(className, variation);
  return _react2.default.createElement(_BaseButton2.default, _extends({ buttonType: 'primary', className: classes }, buttonProps));
};

PrimaryButton.defaultProps = {
  className: '',
  size: 'md',
  variation: ''
};

// Also accepts all <button /> attributes
PrimaryButton.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(_ButtonSizes2.default).isRequired,
  variation: _propTypes2.default.oneOf(['', 'alternative', 'destructive'])
};

exports.default = PrimaryButton;

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BaseButton = __webpack_require__(121);

var _BaseButton2 = _interopRequireDefault(_BaseButton);

var _ButtonSizes = __webpack_require__(52);

var _ButtonSizes2 = _interopRequireDefault(_ButtonSizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TertiaryButton = function TertiaryButton(props) {
  var variation = props.variation,
      className = props.className,
      buttonProps = _objectWithoutProperties(props, ['variation', 'className']);

  var classes = (0, _classnames2.default)(className, variation);
  return _react2.default.createElement(_BaseButton2.default, _extends({ buttonType: 'tertiary', className: classes }, buttonProps));
};

TertiaryButton.defaultProps = {
  className: '',
  size: 'md',
  variation: ''
};

// Also accepts all <button /> attributes
TertiaryButton.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(_ButtonSizes2.default).isRequired,
  variation: _propTypes2.default.oneOf(['', 'alternative', 'destructive', 'white'])
};

exports.default = TertiaryButton;

/***/ }),

/***/ 253:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _BaseButton = __webpack_require__(121);

var _BaseButton2 = _interopRequireDefault(_BaseButton);

var _ButtonSizes = __webpack_require__(52);

var _ButtonSizes2 = _interopRequireDefault(_ButtonSizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SecondaryButton = function SecondaryButton(props) {
  var variation = props.variation,
      className = props.className,
      buttonProps = _objectWithoutProperties(props, ['variation', 'className']);

  var classes = (0, _classnames2.default)(className, variation);
  return _react2.default.createElement(_BaseButton2.default, _extends({ buttonType: 'secondary', className: classes }, buttonProps));
};

SecondaryButton.defaultProps = {
  className: '',
  size: 'md',
  variation: ''
};

// Also accepts all <button /> attributes
SecondaryButton.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(_ButtonSizes2.default).isRequired,
  variation: _propTypes2.default.oneOf(['', 'dark', 'alternative', 'destructive'])
};

exports.default = SecondaryButton;

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeadTermStateMobileNavMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _Icons = __webpack_require__(519);

var _Buttons = __webpack_require__(486);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MenuOption = _react2.default.memo(function (_ref) {
  var href = _ref.href,
      text = _ref.text,
      toggleMenu = _ref.toggleMenu;
  return _react2.default.createElement(
    'div',
    { className: 'head-term-page-nav-item-wrapper-mobile', key: href },
    _react2.default.createElement(
      'a',
      { href: href, onClick: toggleMenu },
      _react2.default.createElement(
        'div',
        { className: 'head-term-page-nav-item head-term-page-nav-item-mobile' },
        _react2.default.createElement(
          'div',
          { className: 'selected-indicator' },
          _react2.default.createElement('div', { className: 'selected-indicator-bar' }),
          _react2.default.createElement('div', { className: 'selected-indicator-arrow' })
        ),
        text
      )
    )
  );
});

var HeadTermStateMobileNavMenu = exports.HeadTermStateMobileNavMenu = function (_React$PureComponent) {
  _inherits(HeadTermStateMobileNavMenu, _React$PureComponent);

  _createClass(HeadTermStateMobileNavMenu, null, [{
    key: 'init',
    value: function init(id, props) {
      _reactDom2.default.render(_react2.default.createElement(HeadTermStateMobileNavMenu, props), document.getElementById(id));
    }
  }]);

  function HeadTermStateMobileNavMenu(props) {
    _classCallCheck(this, HeadTermStateMobileNavMenu);

    var _this = _possibleConstructorReturn(this, (HeadTermStateMobileNavMenu.__proto__ || Object.getPrototypeOf(HeadTermStateMobileNavMenu)).call(this, props));

    _this.state = {
      isMenuOpen: false,
      menuItems: []
    };

    _this.onCreateClick = _this.onCreateClick.bind(_this);
    _this.toggleMenu = _this.toggleMenu.bind(_this);
    _this.getMenuAction = _this.getMenuAction.bind(_this);
    _this.getMenuOptions = _this.getMenuOptions.bind(_this);
    _this.cacheMenuItems = _this.cacheMenuItems.bind(_this);
    return _this;
  }

  _createClass(HeadTermStateMobileNavMenu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Cache menu items once on mount
      this.cacheMenuItems();

      window.addEventListener('resize', this.cacheMenuItems);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.cacheMenuItems);
    }
  }, {
    key: 'onCreateClick',
    value: function onCreateClick() {
      window.location.assign(this.props.ctaLink);
    }
  }, {
    key: 'getMenuOptions',
    value: function getMenuOptions() {
      var _this2 = this;

      var navBarMenuClasses = (0, _classnames2.default)('navbar-menu-item-container', {
        hidden: !this.state.isMenuOpen
      });

      return _react2.default.createElement(
        'div',
        { className: navBarMenuClasses },
        this.state.menuItems.map(function (_ref2) {
          var href = _ref2.href,
              text = _ref2.text;
          return _react2.default.createElement(MenuOption, {
            key: href,
            href: href,
            text: text,
            toggleMenu: _this2.toggleMenu
          });
        })
      );
    }
  }, {
    key: 'getMenuAction',
    value: function getMenuAction() {
      var actionText = this.state.isMenuOpen ? 'Close' : 'Menu';
      var ActionIconComponent = this.state.isMenuOpen ? _Icons.CloseSmallIcon : _Icons.MenuIcon;
      var actionIcon = _react2.default.createElement(ActionIconComponent, {
        className: 'ds-icon-default cursor-pointer head-term-state-navbar-menu-icon'
      });

      return _react2.default.createElement(
        'div',
        { className: 'head-term-state-navbar-icon-wrapper' },
        _react2.default.createElement(
          _Buttons.TertiaryButton,
          {
            className: 'head-term-state-navbar-action',
            icon: actionIcon,
            onClick: this.toggleMenu,
            size: 'sm'
          },
          actionText
        )
      );
    }
  }, {
    key: 'cacheMenuItems',
    value: function cacheMenuItems() {
      var navBarItemElements = [].concat(_toConsumableArray(document.querySelectorAll('.head-term-page-nav-item:not(.head-term-page-nav-item-mobile)')));

      // Process elements once and store results
      var menuItems = navBarItemElements.filter(function (el) {
        var style = window.getComputedStyle(el);
        return style.display !== 'none' && style.visibility !== 'hidden';
      }).map(function (e) {
        var href = e.parentElement.href.match(/#.*$/)[0];
        var nbspRegEx = new RegExp(String.fromCharCode(160), 'g');
        var text = e.textContent.replace(nbspRegEx, ' ').replace(/^\s+/, '');

        return { href: href, text: text };
      });

      this.setState({ menuItems: menuItems });
    }
  }, {
    key: 'toggleMenu',
    value: function toggleMenu() {
      document.querySelector('body').classList.toggle('head-term-state-nav-mobile-menu-open');
      this.setState(function (prevState) {
        return {
          isMenuOpen: !prevState.isMenuOpen
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var navBarHeaderClasses = (0, _classnames2.default)('head-term-state-navbar-header-mobile', { 'menu-open': this.state.isMenuOpen });

      return _react2.default.createElement(
        'div',
        { className: 'head-term-state-navbar-wrapper-mobile' },
        _react2.default.createElement(
          'div',
          { className: navBarHeaderClasses },
          this.getMenuAction(),
          _react2.default.createElement(
            _Buttons.PrimaryButton,
            {
              className: 'create-document-cta',
              onClick: this.onCreateClick,
              size: 'sm'
            },
            'Create My Document'
          )
        ),
        this.getMenuOptions()
      );
    }
  }]);

  return HeadTermStateMobileNavMenu;
}(_react2.default.PureComponent);

HeadTermStateMobileNavMenu.propTypes = {
  ctaLink: _propTypes2.default.string.isRequired
};

exports.default = HeadTermStateMobileNavMenu;

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _HeadTermStateMobileNavMenu = __webpack_require__(443);

var _HeadTermStateMobileNavMenu2 = _interopRequireDefault(_HeadTermStateMobileNavMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.HeadTermStateMobileNavMenu = _HeadTermStateMobileNavMenu2.default;

/***/ }),

/***/ 480:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PrimaryButton = __webpack_require__(173);

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _ButtonSizes = __webpack_require__(52);

var _ButtonSizes2 = _interopRequireDefault(_ButtonSizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlternativePrimaryButton = function AlternativePrimaryButton(props) {
  return _react2.default.createElement(_PrimaryButton2.default, _extends({ variation: 'alternative' }, props));
};

AlternativePrimaryButton.defaultProps = {
  size: 'md'
};

// Also accepts all <button /> attributes
AlternativePrimaryButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(_ButtonSizes2.default).isRequired
};

exports.default = AlternativePrimaryButton;

/***/ }),

/***/ 481:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TertiaryButton = __webpack_require__(174);

var _TertiaryButton2 = _interopRequireDefault(_TertiaryButton);

var _ButtonSizes = __webpack_require__(52);

var _ButtonSizes2 = _interopRequireDefault(_ButtonSizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlternativeTertiaryButton = function AlternativeTertiaryButton(props) {
  return _react2.default.createElement(_TertiaryButton2.default, _extends({ variation: 'alternative' }, props));
};

AlternativeTertiaryButton.defaultProps = {
  size: 'md'
};

// Also accepts all <button /> attributes
AlternativeTertiaryButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(_ButtonSizes2.default).isRequired
};

exports.default = AlternativeTertiaryButton;

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SecondaryButton = __webpack_require__(253);

var _SecondaryButton2 = _interopRequireDefault(_SecondaryButton);

var _ButtonSizes = __webpack_require__(52);

var _ButtonSizes2 = _interopRequireDefault(_ButtonSizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DarkSecondaryButton = function DarkSecondaryButton(props) {
  return _react2.default.createElement(_SecondaryButton2.default, _extends({ variation: 'dark' }, props));
};

DarkSecondaryButton.defaultProps = {
  size: 'md'
};

// Also accepts all <button /> attributes
DarkSecondaryButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(_ButtonSizes2.default).isRequired
};

exports.default = DarkSecondaryButton;

/***/ }),

/***/ 483:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PrimaryButton = __webpack_require__(173);

var _PrimaryButton2 = _interopRequireDefault(_PrimaryButton);

var _ButtonSizes = __webpack_require__(52);

var _ButtonSizes2 = _interopRequireDefault(_ButtonSizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DestructiveButton = function DestructiveButton(props) {
  return _react2.default.createElement(_PrimaryButton2.default, _extends({ variation: 'destructive' }, props));
};

DestructiveButton.defaultProps = {
  size: 'md'
};

// Also accepts all <button /> attributes
DestructiveButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(_ButtonSizes2.default).isRequired
};

exports.default = DestructiveButton;

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconButton = function IconButton(props) {
  var icon = props.icon,
      className = props.className,
      buttonProps = _objectWithoutProperties(props, ['icon', 'className']);

  var classes = (0, _classnames2.default)('ds-btn-icon', className);
  return _react2.default.createElement(
    'button',
    _extends({
      className: classes
    }, buttonProps),
    icon
  );
};

IconButton.defaultProps = {
  className: ''
};

// Also accepts all <button /> attributes
IconButton.propTypes = {
  className: _propTypes2.default.string,
  icon: _propTypes2.default.node.isRequired
};

exports.default = IconButton;

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TertiaryButton = __webpack_require__(174);

var _TertiaryButton2 = _interopRequireDefault(_TertiaryButton);

var _ButtonSizes = __webpack_require__(52);

var _ButtonSizes2 = _interopRequireDefault(_ButtonSizes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WhiteTertiaryButton = function WhiteTertiaryButton(props) {
  return _react2.default.createElement(_TertiaryButton2.default, _extends({ variation: 'white' }, props));
};

WhiteTertiaryButton.defaultProps = {
  size: 'md'
};

// Also accepts all <button /> attributes
WhiteTertiaryButton.propTypes = {
  onClick: _propTypes2.default.func.isRequired,
  size: _propTypes2.default.oneOf(_ButtonSizes2.default).isRequired
};

exports.default = WhiteTertiaryButton;

/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrimaryButton = __webpack_require__(173);

Object.defineProperty(exports, 'PrimaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrimaryButton).default;
  }
});

var _SecondaryButton = __webpack_require__(253);

Object.defineProperty(exports, 'SecondaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SecondaryButton).default;
  }
});

var _DarkSecondaryButton = __webpack_require__(482);

Object.defineProperty(exports, 'DarkSecondaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DarkSecondaryButton).default;
  }
});

var _TertiaryButton = __webpack_require__(174);

Object.defineProperty(exports, 'TertiaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TertiaryButton).default;
  }
});

var _WhiteTertiaryButton = __webpack_require__(485);

Object.defineProperty(exports, 'WhiteTertiaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WhiteTertiaryButton).default;
  }
});

var _DestructiveButton = __webpack_require__(483);

Object.defineProperty(exports, 'DestructiveButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DestructiveButton).default;
  }
});

var _AlternativePrimaryButton = __webpack_require__(480);

Object.defineProperty(exports, 'AlternativePrimaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlternativePrimaryButton).default;
  }
});

var _AlternativeTertiaryButton = __webpack_require__(481);

Object.defineProperty(exports, 'AlternativeTertiaryButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlternativeTertiaryButton).default;
  }
});

var _IconButton = __webpack_require__(484);

Object.defineProperty(exports, 'IconButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_IconButton).default;
  }
});

var _BaseButton = __webpack_require__(121);

Object.defineProperty(exports, 'BaseButton', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BaseButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddFillableFieldsIcon = function AddFillableFieldsIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M1,3 L15,3 C15.5522847,3 16,3.44771525 16,4 L16,12 C16,12.5522847 15.5522847,13 15,13 L1,13 C0.44771525,13 0,12.5522847 0,12 L0,4 C0,3.44771525 0.44771525,3 1,3 Z M2,5 L2,11 L14,11 L14,5 L2,5 Z M4,8 L12,8 C12.5522847,8 13,8.44771525 13,9 C13,9.55228475 12.5522847,10 12,10 L4,10 C3.44771525,10 3,9.55228475 3,9 C3,8.44771525 3.44771525,8 4,8 Z', fill: '#8C99AD', fillRule: 'nonzero' })
    )
  );
};

exports.default = AddFillableFieldsIcon;

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AddRecipientsIcon = function AddRecipientsIcon(props) {
  var pathData = ['M10.5 5.63111C8.96588 5.63111 7.72222 4.37054 7.72222 2.81556C7.72222 1.26057 8.96588 0 10.5', '0C12.0341 0 13.2778 1.26057 13.2778 2.81556C13.2778 4.37054 12.0341 5.63111', '10.5 5.63111ZM15.5 10.5583C15.5 12.8908 5.5 12.8908 5.5 10.5583C5.5 8.22585 7.73858 6.335', '10.5 6.335C13.2614 6.335 15.5 8.22585 15.5 10.5583ZM2.5 4V2.5C2.5 2.22386 2.72386 2 3', '2C3.27614 2 3.5 2.22386 3.5 2.5V4H5C5.27614 4 5.5 4.22386 5.5 4.5C5.5 4.77614 5.27614 5 5', '5H3.5V6.5C3.5 6.77614 3.27614 7 3 7C2.72386 7 2.5 6.77614 2.5 6.5V5H1C0.723858 5 0.5 4.77614', '0.5 4.5C0.5 4.22386 0.723858 4 1 4H2.5Z'].join(' ');

  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: pathData })
    )
  );
};

exports.default = AddRecipientsIcon;

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement(
        'g',
        { transform: 'translate(8.000000, 8.000000) scale(-1, 1) translate(-8.000000, -8.000000) translate(0.000000, 3.000000)', fillRule: 'nonzero' },
        _react2.default.createElement('path', { d: 'M12.5213203,6 L1,6 C0.44771525,6 -9.99200722e-13,5.55228475 -9.99200722e-13,5 C-9.99200722e-13,4.44771525 0.44771525,4 1,4 L12.6218254,4 L10.7431458,2.12132034 C10.3526215,1.73079605 10.3526215,1.09763107 10.7431458,0.707106781 C11.13367,0.316582489 11.766835,0.316582489 12.1573593,0.707106781 L15.6928932,4.24264069 C16.0834175,4.63316498 16.0834175,5.26632996 15.6928932,5.65685425 L12.1573593,9.19238816 C11.766835,9.58291245 11.13367,9.58291245 10.7431458,9.19238816 C10.3526215,8.80186386 10.3526215,8.16869888 10.7431458,7.77817459 L12.5213203,6 Z' })
      )
    )
  );
};

exports.default = ArrowLeftIcon;

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArrowRightIcon = function ArrowRightIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement(
        'g',
        { transform: 'translate(0.000000, 3.000000)', fillRule: 'nonzero' },
        _react2.default.createElement('path', { d: 'M12.5213203,6 L1,6 C0.44771525,6 -1.00097708e-12,5.55228475 -1.00097708e-12,5 C-1.00097708e-12,4.44771525 0.44771525,4 1,4 L12.6218254,4 L10.7431458,2.12132034 C10.3526215,1.73079605 10.3526215,1.09763107 10.7431458,0.707106781 C11.13367,0.316582489 11.766835,0.316582489 12.1573593,0.707106781 L15.6928932,4.24264069 C16.0834175,4.63316498 16.0834175,5.26632996 15.6928932,5.65685425 L12.1573593,9.19238816 C11.766835,9.58291245 11.13367,9.58291245 10.7431458,9.19238816 C10.3526215,8.80186386 10.3526215,8.16869888 10.7431458,7.77817459 L12.5213203,6 Z' })
      )
    )
  );
};

exports.default = ArrowRightIcon;

/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This icon only exists within the context of the Checkboxes component
var CheckMarkIcon = function CheckMarkIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement(
        'g',
        { transform: 'translate(-3.000000, -6.000000)', fillRule: 'nonzero' },
        _react2.default.createElement('path', {
          d: 'M11.0710678,12.0710678 L11.0710678,4.57106781 C11.0710678,3.74264069 11.7426407,3.07106781 12.5710678,3.07106781 C13.3994949,3.07106781 14.0710678,3.74264069 14.0710678,4.57106781 L14.0710678,13.5710678 C14.0710678,14.3994949 13.3994949,15.0710678 12.5710678,15.0710678 L7.57106781,15.0710678 C6.74264069,15.0710678 6.07106781,14.3994949 6.07106781,13.5710678 C6.07106781,12.7426407 6.74264069,12.0710678 7.57106781,12.0710678 L11.0710678,12.0710678 Z',
          transform: 'translate(10.071068, 9.071068) rotate(-315.000000) translate(-10.071068, -9.071068)'
        })
      )
    )
  );
};

exports.default = CheckMarkIcon;

/***/ }),

/***/ 492:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClockIcon = function ClockIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { id: 'clock-icon', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M8,15.0588235 C11.8984806,15.0588235 15.0588235,11.8984806 15.0588235,8 C15.0588235,4.10151941 11.8984806,0.941176471 8,0.941176471 C4.10151941,0.941176471 0.941176471,4.10151941 0.941176471,8 C0.941176471,11.8984806 4.10151941,15.0588235 8,15.0588235 Z M8.47058824,3.23362019 L8.47058824,7.77571167 L11.0731519,9.88577512 C11.2750344,10.0494541 11.3060045,10.3458002 11.1423255,10.5476827 C10.9786466,10.7495651 10.6823005,10.7805352 10.480418,10.6168563 L7.52941176,8.22428833 L7.52941176,3.23362019 C7.52941176,2.97372149 7.74010129,2.76303196 8,2.76303196 C8.25989871,2.76303196 8.47058824,2.97372149 8.47058824,3.23362019 Z', id: 'Combined-Shape', fill: '#8C99AD', fillRule: 'nonzero' })
    )
  );
};

exports.default = ClockIcon;

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseIcon = function CloseIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M7.99139215,6.57717859 L14.2746831,0.311104672 C14.6657428,-0.0788834754 15.2989072,-0.0780148095 15.6888953,0.313044892 C16.0788835,0.704104593 16.0780148,1.33726898 15.6869551,1.72725712 L9.40560705,7.99139349 L15.668745,14.2545314 C16.0592693,14.6450557 16.0592693,15.2782207 15.668745,15.668745 C15.2782207,16.0592693 14.6450557,16.0592693 14.2545314,15.668745 L7.98945326,9.40366683 L1.68695511,15.6888953 C1.29589541,16.0788835 0.662731024,16.0780148 0.272742877,15.6869551 C-0.11724527,15.2958954 -0.116376605,14.662731 0.274683097,14.2727429 L6.57523837,7.98945193 L0.292893219,1.70710678 C-0.0976310729,1.31658249 -0.0976310729,0.683417511 0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 L7.99139215,6.57717859 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = CloseIcon;

/***/ }),

/***/ 494:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CloseSmallIcon = function CloseSmallIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M8,6.58662318 L11.2949286,3.2924746 C11.685314,2.90218164 12.3178791,2.9025566 12.7078024,3.29331209 C13.0977257,3.68406758 13.0973511,4.31723245 12.7069657,4.7075254 L9.41371149,8 L12.7069657,11.2924746 C13.0973511,11.6827676 13.0977257,12.3159324 12.7078024,12.7066879 C12.3178791,13.0974434 11.685314,13.0978184 11.2949286,12.7075254 L8,9.41337682 L4.70507138,12.7075254 C4.314686,13.0978184 3.68212085,13.0974434 3.29219757,12.7066879 C2.90227429,12.3159324 2.90264889,11.6827676 3.29303427,11.2924746 L6.5862885,8 L3.29303427,4.7075254 C2.90264889,4.31723245 2.90227429,3.68406758 3.29219757,3.29331209 C3.68212085,2.9025566 4.314686,2.90218164 4.70507138,3.2924746 L8,6.58662318 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = CloseSmallIcon;

/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreateIcon = function CreateIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M10.8511377,3.86249215 L12.3215117,5.62694096 L13.0856155,4.92328155 C13.1845726,4.8075729 13.1927067,4.61303512 13.1152701,4.51012618 L11.9377255,3.05370377 C11.8800728,2.98784664 11.81057,2.98326013 11.7637216,3.02474616 L10.8511377,3.86249215 Z M9.38806572,5.23090571 L2.60207858,11.4886487 L2.32803848,13.3165595 L3.9754556,13.2891532 L10.8564884,6.99301287 L9.38806572,5.23090571 Z M14.5085948,6.32959547 L14.4684955,6.36865252 L13.3660492,7.38057611 L13.1157992,7.64560754 L12.999637,7.76253528 L12.699012,8.02756671 L12.4121509,8.28023571 L4.76646805,15.2762707 L-4.22772928e-13,15.3555654 L0.728584965,10.495735 L0.987417049,10.2570513 L8.3701526,3.44935304 L8.67077762,3.18432161 L8.90561541,2.98286742 L8.95599042,2.92951693 L9.25588048,2.61545853 L10.4215469,1.542089 C11.3134604,0.748509422 12.6553187,0.837059285 13.4675198,1.76598186 L14.689457,3.27686127 C15.3848556,4.1939035 15.3088348,5.50526766 14.5085948,6.32959547 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = CreateIcon;

/***/ }),

/***/ 496:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DuplicateIcon = function DuplicateIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M2,2 L2,12 L0,12 L0,2 L0,0 L12,0 L12,2 L2,2 Z M14,6 L6,6 L6,14 L14,14 L14,6 Z M16,4 L16,16 L4,16 L4,4 L16,4 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = DuplicateIcon;

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FolderIcon = function FolderIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M1 14C0.715086 14 0.458 13.8808 0.275857 13.6897C0.10493 13.5102 0 13.2674 0 13V5C0 4.44772 0.447715 4 1 4H2V3C2 2.44772 2.44772 2 3 2H8C8.55228 2 9 2.44772 9 3V4H13C13.5523 4 14 4.44772 14 5V6H7V4H4V6H2V11.6667L4 7H16L13 14H1ZM11.6812 12L12.9669 9H5.31879L4.03308 12H11.6812Z', fill: '#0088CC' })
    )
  );
};

exports.default = FolderIcon;

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelpIcon = function HelpIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 Z M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M7.123,10.306 L8.85,10.306 L8.85,12 L7.123,12 L7.123,10.306 Z M5.352,6.676 C5.35933337,6.27999802 5.42716602,5.91700165 5.5555,5.587 C5.68383397,5.25699835 5.86349884,4.97100121 6.0945,4.729 C6.32550115,4.48699879 6.60416503,4.29816734 6.9305,4.1625 C7.25683496,4.02683265 7.62166465,3.959 8.025,3.959 C8.54566927,3.959 8.98016492,4.03049928 9.3285,4.1735 C9.67683507,4.31650071 9.95733227,4.49433227 10.17,4.707 C10.3826677,4.91966773 10.5348329,5.1488321 10.6265,5.3945 C10.7181671,5.64016789 10.764,5.86933227 10.764,6.082 C10.764,6.43400176 10.7181671,6.72366553 10.6265,6.951 C10.5348329,7.17833447 10.4211673,7.37266586 10.2855,7.534 C10.1498327,7.69533414 9.99950082,7.83283276 9.8345,7.9465 C9.66949917,8.06016723 9.5136674,8.17383276 9.367,8.2875 C9.2203326,8.40116723 9.09016723,8.5313326 8.9765,8.678 C8.86283276,8.8246674 8.79133348,9.0079989 8.762,9.228 L8.762,9.646 L7.277,9.646 L7.277,9.151 C7.29900011,8.83566509 7.3594995,8.57166773 7.4585,8.359 C7.55750049,8.14633227 7.67299934,7.96483408 7.805,7.8145 C7.93700066,7.66416591 8.0763326,7.53400055 8.223,7.424 C8.3696674,7.31399945 8.50533271,7.20400055 8.63,7.094 C8.75466729,6.98399945 8.85549961,6.86300066 8.9325,6.731 C9.00950038,6.59899934 9.04433337,6.43400099 9.037,6.236 C9.037,5.89866498 8.95450082,5.64933414 8.7895,5.488 C8.62449917,5.32666586 8.3953348,5.246 8.102,5.246 C7.90399901,5.246 7.73350071,5.28449961 7.5905,5.3615 C7.44749928,5.43850038 7.33016712,5.54116602 7.2385,5.6695 C7.14683287,5.79783397 7.07900022,5.9481658 7.035,6.1205 C6.99099978,6.29283419 6.969,6.47799901 6.969,6.676 L5.352,6.676 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = HelpIcon;

/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuIcon = function MenuIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M1,3 L15,3 C15.5522847,3 16,3.44771525 16,4 C16,4.55228475 15.5522847,5 15,5 L1,5 C0.44771525,5 6.76353751e-17,4.55228475 0,4 C-6.76353751e-17,3.44771525 0.44771525,3 1,3 Z M1,7 L15,7 C15.5522847,7 16,7.44771525 16,8 C16,8.55228475 15.5522847,9 15,9 L1,9 C0.44771525,9 6.76353751e-17,8.55228475 0,8 C-6.76353751e-17,7.44771525 0.44771525,7 1,7 Z M1,11 L15,11 C15.5522847,11 16,11.4477153 16,12 C16,12.5522847 15.5522847,13 15,13 L1,13 C0.44771525,13 6.76353751e-17,12.5522847 0,12 C-6.76353751e-17,11.4477153 0.44771525,11 1,11 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = MenuIcon;

/***/ }),

/***/ 500:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OpenNewIcon = function OpenNewIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M14,3.41421356 L8.70710678,8.70710678 C8.31658249,9.09763107 7.68341751,9.09763107 7.29289322,8.70710678 C6.90236893,8.31658249 6.90236893,7.68341751 7.29289322,7.29289322 L12.5857864,2 L9,2 C8.44771525,2 8,1.55228475 8,1 C8,0.44771525 8.44771525,0 9,0 L16,0 L16,7 C16,7.55228475 15.5522847,8 15,8 C14.4477153,8 14,7.55228475 14,7 L14,3.41421356 Z M1.09440235e-13,9.5 L1.11022302e-13,-2.79880645e-14 L3.94873047,-2.72626945e-14 C4.50101522,-2.71612414e-14 4.94873047,0.44771525 4.94873047,1 C4.94873047,1.55228475 4.50101522,2 3.94873047,2 L2,2 L2,9.5 L2,14 L14,14 L14,12.0524902 C14,11.5002055 14.4477153,11.0524902 15,11.0524902 C15.5522847,11.0524902 16,11.5002055 16,12.0524902 L16,16 L1.33226763e-14,16 L1.33226763e-14,9.5 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = OpenNewIcon;

/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrganizeTemplateIcon = function OrganizeTemplateIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M3.89259839,12.75 L5.54289322,12.75 C5.60919734,12.75 5.67278582,12.7763392 5.71966991,12.8232233 C5.81730099,12.9208544 5.81730099,13.0791456 5.71966991,13.1767767 L2.89644661,16 L0.0732233047,13.1767767 C0.0263392101,13.1298926 -3.04689607e-12,13.0663041 -3.04689607e-12,13 C-3.04689607e-12,12.8619288 0.111928813,12.75 0.25,12.75 L1.90249518,12.75 L1.8964491,10.0022113 C1.89523388,9.44992794 2.33974636,9.00122376 2.8892955,9.0000025 C3.43884464,8.99878124 3.88532736,9.44550537 3.88654258,9.99778877 L3.89259839,12.75 Z M3.89039804,3.25 L3.89644412,5.99778871 C3.89765934,6.55007211 3.45314686,6.9987763 2.90359772,6.99999756 C2.35404858,7.00121881 1.90756586,6.55449469 1.90635064,6.00221129 L1.90029483,3.25 L0.25,3.25 C0.111928813,3.25 -3.04689607e-12,3.13807119 -3.04689607e-12,3 C-3.04689607e-12,2.93369588 0.0263392101,2.8701074 0.0732233047,2.8232233 L2.89644661,-1.97054179e-12 L5.71966991,2.8232233 C5.81730099,2.92085438 5.81730099,3.07914562 5.71966991,3.1767767 C5.67278582,3.22366079 5.60919734,3.25 5.54289322,3.25 L3.89039804,3.25 Z M7.89644661,1 L14.8964466,1 C15.4487314,1 15.8964466,1.44771525 15.8964466,2 C15.8964466,2.55228475 15.4487314,3 14.8964466,3 L7.89644661,3 C7.34416186,3 6.89644661,2.55228475 6.89644661,2 C6.89644661,1.44771525 7.34416186,1 7.89644661,1 Z M7.89644661,5 L14.8964466,5 C15.4487314,5 15.8964466,5.44771525 15.8964466,6 C15.8964466,6.55228475 15.4487314,7 14.8964466,7 L7.89644661,7 C7.34416186,7 6.89644661,6.55228475 6.89644661,6 C6.89644661,5.44771525 7.34416186,5 7.89644661,5 Z M7.89644661,9 L14.8964466,9 C15.4487314,9 15.8964466,9.44771525 15.8964466,10 C15.8964466,10.5522847 15.4487314,11 14.8964466,11 L7.89644661,11 C7.34416186,11 6.89644661,10.5522847 6.89644661,10 C6.89644661,9.44771525 7.34416186,9 7.89644661,9 Z M7.89644661,13 L14.8964466,13 C15.4487314,13 15.8964466,13.4477153 15.8964466,14 C15.8964466,14.5522847 15.4487314,15 14.8964466,15 L7.89644661,15 C7.34416186,15 6.89644661,14.5522847 6.89644661,14 C6.89644661,13.4477153 7.34416186,13 7.89644661,13 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = OrganizeTemplateIcon;

/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayIcon = function PlayIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 Z M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z M6.3525812,4.1224188 L11.7400278,7.991 L6.3525812,11.8595812 L6.3525812,4.1224188 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = PlayIcon;

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlusIcon = function PlusIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M9,9 L9,11.2 C9,11.6418278 8.55228475,12 8,12 C7.44771525,12 7,11.6418278 7,11.2 L7,9 L4.8,9 C4.3581722,9 4,8.55228475 4,8 C4,7.44771525 4.3581722,7 4.8,7 L7,7 L7,4.8 C7,4.3581722 7.44771525,4 8,4 C8.55228475,4 9,4.3581722 9,4.8 L9,7 L11.2,7 C11.6418278,7 12,7.44771525 12,8 C12,8.55228475 11.6418278,9 11.2,9 L9,9 Z M8,14 C11.3137085,14 14,11.3137085 14,8 C14,4.6862915 11.3137085,2 8,2 C4.6862915,2 2,4.6862915 2,8 C2,11.3137085 4.6862915,14 8,14 Z M8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = PlusIcon;

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrepareToSendIcon = function PrepareToSendIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M6.9672697,10.7536446 L9.84797271,7.20816395 C10.1013272,6.89634297 10.0779648,6.44346427 9.79386903,6.15936847 C9.50977324,5.87527268 9.05689453,5.85191026 8.74507356,6.10526479 L5.1372854,9.03659267 L0.76308561,6.68125432 C0.656563408,6.62389621 0.574450967,6.52986059 0.531970933,6.41658049 C0.435010872,6.15802033 0.566013638,5.86981425 0.824573801,5.77285418 L14.8006238,0.531835422 C14.9093612,0.491058924 15.0289014,0.489404705 15.1387254,0.527156711 C15.3998696,0.61692501 15.5387972,0.901395751 15.4490289,1.16253989 L10.6378964,15.1585614 C10.6002461,15.2680897 10.5257399,15.3611504 10.4271019,15.4218507 C10.1919229,15.5665762 9.8839495,15.4932492 9.73922399,15.2580703 L6.9672697,10.7536446 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = PrepareToSendIcon;

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PreviewIcon = function PreviewIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M8,14 C4.78670691,14 1,12 0,8 C1,4 4.78670691,2 8,2 C11.2132931,2 15,4 16,8 C15,12 11.2132931,14 8,14 Z M8,12 C10.209139,12 12,10.209139 12,8 C12,5.790861 10.209139,4 8,4 C5.790861,4 4,5.790861 4,8 C4,10.209139 5.790861,12 8,12 Z M8,10 C6.8954305,10 6,9.1045695 6,8 C6,6.8954305 6.8954305,6 8,6 C9.1045695,6 10,6.8954305 10,8 C10,9.1045695 9.1045695,10 8,10 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = PreviewIcon;

/***/ }),

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrintIcon = function PrintIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M11.5555556,16 L4.44444444,16 L4.44444444,10.3064699 L11.5555556,10.3064699 L11.5555556,16 Z M13.3333333,13.153235 L13.3333333,8.40862656 L2.66666667,8.40862656 L2.66666667,13.153235 L1.77777778,13.153235 C0.795938223,13.153235 3.64153152e-13,12.3035415 3.64153152e-13,11.2553916 L3.64153152e-13,5.56186152 C3.64153152e-13,4.51371158 0.795938223,3.66401816 1.77777778,3.66401816 L2.66666667,3.66401816 L2.66666667,5.56186152 L13.3333333,5.56186152 L13.3333333,3.66401816 L14.2222222,3.66401816 C15.2040618,3.66401816 16,4.51371158 16,5.56186152 L16,11.2553916 C16,12.3035415 15.2040618,13.153235 14.2222222,13.153235 L13.3333333,13.153235 Z M4.44444444,3.66401816 L4.44444444,3.55271368e-15 L11.5555556,3.55271368e-15 L11.5555556,3.66401816 L4.44444444,3.66401816 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = PrintIcon;

/***/ }),

/***/ 507:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReverseIcon = function ReverseIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', {
        d: 'M5 0L8 4H6V10H4V4H2L5 0ZM11 16L8 12L10 12L10 6L12 6L12 12H14L11 16Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd'
      })
    )
  );
};

exports.default = ReverseIcon;

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchIcon = function SearchIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M11.4645043,9.69673737 L15.6338835,13.8661165 C16.1220388,14.3542719 16.1220388,15.1457281 15.6338835,15.6338835 C15.1457281,16.1220388 14.3542719,16.1220388 13.8661165,15.6338835 L9.69673737,11.4645043 C8.7086961,12.118904 7.52385292,12.5 6.25,12.5 C2.79822031,12.5 0,9.70177969 0,6.25 C0,2.79822031 2.79822031,0 6.25,0 C9.70177969,0 12.5,2.79822031 12.5,6.25 C12.5,7.52385292 12.118904,8.7086961 11.4645043,9.69673737 Z M6.25,10.5 C8.59721019,10.5 10.5,8.59721019 10.5,6.25 C10.5,3.90278981 8.59721019,2 6.25,2 C3.90278981,2 2,3.90278981 2,6.25 C2,8.59721019 3.90278981,10.5 6.25,10.5 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = SearchIcon;

/***/ }),

/***/ 509:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SendForSignatureIcon = function SendForSignatureIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M2,3 L2,13 L10.4080976,13 L13.6223833,8 L10.4080976,3 L2,3 Z M-4.88498131e-14,1 L11.5,1 L16,8 L11.5,15 L-4.88498131e-14,15 L-4.88498131e-14,1 Z M6.75,6.58578644 L8.54289322,4.79289322 C8.93341751,4.40236893 9.56658249,4.40236893 9.95710678,4.79289322 C10.3476311,5.18341751 10.3476311,5.81658249 9.95710678,6.20710678 L8.16421356,8 L9.95710678,9.79289322 C10.3476311,10.1834175 10.3476311,10.8165825 9.95710678,11.2071068 C9.56658249,11.5976311 8.93341751,11.5976311 8.54289322,11.2071068 L6.75,9.41421356 L4.95710678,11.2071068 C4.56658249,11.5976311 3.93341751,11.5976311 3.54289322,11.2071068 C3.15236893,10.8165825 3.15236893,10.1834175 3.54289322,9.79289322 L5.33578644,8 L3.54289322,6.20710678 C3.15236893,5.81658249 3.15236893,5.18341751 3.54289322,4.79289322 C3.93341751,4.40236893 4.56658249,4.40236893 4.95710678,4.79289322 L6.75,6.58578644 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = SendForSignatureIcon;

/***/ }),

/***/ 510:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareIcon = function ShareIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M2,4.12682752 L8,8.51144291 L14,4.12682752 L14,4 L2,4 L2,4.12682752 Z M2,6.60394171 L2,12 L14,12 L14,6.60394171 L8.88502488,10.3418081 C8.3578848,10.7270259 7.6421152,10.7270259 7.11497512,10.3418081 L2,6.60394171 Z M0,2 L16,2 L16,14 L0,14 L0,2 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = ShareIcon;

/***/ }),

/***/ 511:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignIcon = function SignIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M11.5,16 C10.9477153,16 10.5,15.5522847 10.5,15 C10.5,14.4477153 10.9477153,14 11.5,14 C12.0522847,14 12.5,14.4477153 12.5,15 C12.5,15.5522847 12.0522847,16 11.5,16 Z M8,16 C7.44771525,16 7,15.5522847 7,15 C7,14.4477153 7.44771525,14 8,14 C8.55228475,14 9,14.4477153 9,15 C9,15.5522847 8.55228475,16 8,16 Z M4.5,16 C3.94771525,16 3.5,15.5522847 3.5,15 C3.5,14.4477153 3.94771525,14 4.5,14 C5.05228475,14 5.5,14.4477153 5.5,15 C5.5,15.5522847 5.05228475,16 4.5,16 Z M1,16 C0.44771525,16 1.1046711e-13,15.5522847 1.1046711e-13,15 C1.1046711e-13,14.4477153 0.44771525,14 1,14 C1.55228475,14 2,14.4477153 2,15 C2,15.5522847 1.55228475,16 1,16 Z M15,16 C14.4477153,16 14,15.5522847 14,15 C14,14.4477153 14.4477153,14 15,14 C15.5522847,14 16,14.4477153 16,15 C16,15.5522847 15.5522847,16 15,16 Z M5.4729983,5.02999894 C4.3030437,6.90192631 2.94331505,9.34943787 1.89442719,11.4472136 C1.64743794,11.9411921 1.0467649,12.1414164 0.552786404,11.8944272 C0.0588079071,11.6474379 -0.14141644,11.0467649 0.105572809,10.5527864 C2.99986035,4.76421132 5.97749243,-9.48660586e-14 7.5,-9.50350909e-14 C8.42083571,-9.50350909e-14 8.67597244,0.632570403 8.68161512,1.42254483 C8.68403174,1.76087248 8.63163336,2.19109075 8.53048156,2.74282787 C8.38183235,3.55364172 8.1948605,4.34366362 7.7201425,6.24253563 C7.5170455,7.05492361 7.36786895,7.65956468 7.25275375,8.14587343 C7.43923726,7.88059664 7.6583983,7.56504615 7.92735323,7.17589161 C10.1802122,3.91619933 10.5192897,3.48888881 11.5,3.48888881 C12.6577964,3.48888881 12.8459303,4.2684093 12.7799421,5.55737752 C12.7514569,6.11378921 12.6818402,6.63680667 12.4884107,7.89624809 C12.3918241,8.52513371 12.3279974,8.95936836 12.2858563,9.29747006 C12.8036168,8.75849134 13.4399159,7.9636527 14.1862665,6.91876181 C14.5072755,6.46934922 15.1318256,6.36525754 15.5812382,6.68626653 C16.0306508,7.00727552 16.1347425,7.63182561 15.8137335,8.08123819 C13.9183556,10.7347672 12.6531228,12 11.5,12 C10.3422036,12 10.1540697,11.2204795 10.2200579,9.93151129 C10.2485431,9.37509961 10.3181598,8.85208215 10.5115893,7.59264072 C10.5582824,7.28861714 10.5973192,7.03008479 10.6299511,6.80591299 C10.3705913,7.16334527 10.0500689,7.62220869 9.57264677,8.31299721 C7.3197878,11.5726895 6.98071035,12 6,12 C5.07916429,12 4.82402756,11.3674296 4.81838488,10.5774552 C4.81596826,10.2391275 4.86836664,9.80890925 4.96951844,9.25717213 C5.11816765,8.44635828 5.3051395,7.65633638 5.7798575,5.75746437 C5.98712682,4.92838709 6.13823751,4.31568011 6.2542979,3.82430415 C6.00955299,4.18631695 5.74805359,4.58991048 5.4729983,5.02999894 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = SignIcon;

/***/ }),

/***/ 512:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathData = ['M16.5241 5.83842C16.3289 5.64315 16.0123 5.64315 15.817 5.83842L14.4028 7.25263C14.2076 7.44789', '14.2076 7.76447 14.4028 7.95974L15.817 9.37395L16.8777 10.4346L14.4028 12.9095C14.2076 13.1047', '14.2076 13.4213 14.4028 13.6166C14.5981 13.8119 14.9147 13.8119 15.1099 13.6166L17.5848', '11.1417C17.9753 10.7512 17.9753 10.118 17.5848 9.7275L16.8777 9.0204L17.9384 7.95974C18.1336', '7.76447 18.1336 7.44789 17.9384 7.25263L16.5241 5.83842ZM12.9886 8.66684C13.1839 8.47158', '13.5005 8.47158 13.6957 8.66684L15.1099 10.0811C15.3052 10.2763 15.3052 10.5929 15.1099', '10.7882L9.09953 16.7986L6.86623 17.543C6.47535 17.6733 6.10348 17.3014 6.23377 16.9105L6.97821', '14.6773L12.9886 8.66684Z'].join(' ');

var SignIllustrationIcon = function SignIllustrationIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', fill: 'none', fillRule: 'evenOdd', clipRule: 'evenodd' },
      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '11', strokeWidth: '2', stroke: 'currentColor' }),
      _react2.default.createElement('path', { strokeWidth: '1', d: pathData })
    )
  );
};

exports.default = SignIllustrationIcon;

/***/ }),

/***/ 513:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathData = ['M2.3999 0H3.9999V2.39999H7.1999V0H8.7999V2.39999H11.9999V0H13.5999V2.39999H16V16H0V2.39999H2.', '3999V0ZM4.8001 6.40002H1.6001V9.60003H4.8001V6.40002ZM9.6001 6.40002H6.4001V9.60003H9.6001V6.', '40002ZM14.4001 6.40002H11.2001V9.60003H14.4001V6.40002ZM4.8001 11.2H1.6001V14.4H4.8001V11.2ZM9.', '6001 11.2H6.4001V14.4H9.6001V11.2ZM14.4001 11.2H11.2001V14.4H14.4001V11.2Z'].join('');

var SigningDateIcon = function SigningDateIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: pathData })
    )
  );
};

exports.default = SigningDateIcon;

/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathData1 = 'M16 14.4009H0V16H16V14.4009Z';
var pathData2 = ['M2.46378 10.0035L0.749596 8.11418L1.56923 7.2171L3.28341 9.10561L5.00778 7.2171L5.82741 ', '8.11418L4.09141 10.0035L5.82741 11.8928L5.00778 12.7899L3.28341 10.8886L1.54741 ', '12.7899L0.727051 11.8912L2.46378 10.0035Z'].join('');
var pathData3 = ['M11.8635 13.5862C11.759 13.5838 11.6567 13.5524 11.5661 13.495C10.4272 12.817 10.7624 10.2697 ', '11.7392 5.01994C11.905 4.13085 12.0934 3.11784 12.2112 2.33189C10.5029 5.89724 8.97735 9.56486 ', '7.64172 13.3175L6.55518 12.7219C11.0766 0.79438 12.0272 -0.326574 12.9923 0.062002C13.8228 ', '0.39541 13.5915 1.63949 12.9043 5.33336C12.5111 7.25101 12.2228 9.19284 12.041 11.1484C12.4388 ', '10.3944 13.0082 9.76729 13.6934 9.32865C14.1531 9.05236 14.6591 8.88154 15.1806 8.82654L15.289 ', '10.2553C14.9177 10.2938 14.5575 10.4149 14.2301 10.6111C13.5222 11.1225 12.9728 11.8588 ', '12.6548 12.7219C12.5469 13.1424 12.2467 13.4702 11.8635 13.5862Z'].join('');

var SigningSignIcon = function SigningSignIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: pathData1 }),
      _react2.default.createElement('path', { d: pathData2 }),
      _react2.default.createElement('path', { d: pathData3 })
    )
  );
};

exports.default = SigningSignIcon;

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathData = ['M11.7411 1.54322L13.1438 0.140487C13.3318 -0.046829 13.6358 -0.046829 13.8238 0.140487L15.86 ', '2.17668C16.0467 2.36451 16.0467 2.66787 15.86 2.8557L14.4572 4.25843L11.7411 1.54322ZM2.92002 ', '13.1135L1.56553 11.7679L0.022534 15.7831C-0.0444753 15.9574 0.0430835 16.044 0.217308 ', '15.977L4.23787 14.434L2.92002 13.1135ZM12.5041 3.73219L11.0246 2.26066L2.25886 11.0264L4.97497 ', '13.7425L13.7416 4.97498L12.5041 3.73219Z'].join('');

var SigningTextIcon = function SigningTextIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: pathData })
    )
  );
};

exports.default = SigningTextIcon;

/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrashIcon = function TrashIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M3.99169944,4 L12.008252,4 C12.5605367,4 13.008252,4.44771525 13.008252,5 C13.008252,5.02802281 13.007074,5.05603324 13.0047213,5.08395711 L12.1621755,15.0839571 C12.1185399,15.6018594 11.6854435,16 11.1657062,16 L4.84514715,16 C4.3258254,16 3.8929301,15.6024764 3.84876924,15.0850356 L2.99532153,5.08503564 C2.94835764,4.53475132 3.35637948,4.05058598 3.9066638,4.00362209 C3.93494476,4.00120846 3.96331567,4 3.99169944,4 Z M8.5,6 C8.5,5.72385763 8.27614237,5.5 8,5.5 C7.72385763,5.5 7.5,5.72385763 7.5,6 L7.5,14 C7.5,14.2761424 7.72385763,14.5 8,14.5 C8.27614237,14.5 8.5,14.2761424 8.5,14 L8.5,6 Z M10.972265,5.99923018 C10.9727504,5.99049295 10.9729932,5.98174393 10.9729932,5.97299323 C10.9729932,5.71176628 10.7612269,5.5 10.5,5.5 C10.2194813,5.5 9.98782537,5.71914342 9.97226499,5.99923018 L9.52773501,14.0007698 C9.52724961,14.0095071 9.52700677,14.0182561 9.52700677,14.0270068 C9.52700677,14.2882337 9.73877305,14.5 10,14.5 C10.2805187,14.5 10.5121746,14.2808566 10.527735,14.0007698 L10.972265,5.99923018 Z M6.02773501,5.99923018 C6.01217463,5.71914342 5.78051866,5.5 5.5,5.5 C5.4912493,5.5 5.48250028,5.50024284 5.47376306,5.50072824 C5.2129383,5.51521851 5.01324475,5.73840542 5.02773501,5.99923018 L5.47226499,14.0007698 C5.48782537,14.2808566 5.71948134,14.5 6,14.5 C6.0087507,14.5 6.01749972,14.4997572 6.02623694,14.4992718 C6.2870617,14.4847815 6.48675525,14.2615946 6.47226499,14.0007698 L6.02773501,5.99923018 Z M10,2 L13.5,2 C13.7761424,2 14,2.22385763 14,2.5 C14,2.77614237 13.7761424,3 13.5,3 L2.5,3 C2.22385763,3 2,2.77614237 2,2.5 C2,2.22385763 2.22385763,2 2.5,2 L6,2 L6,0.5 C6,0.223857625 6.22385763,5.07265313e-17 6.5,0 L9.5,0 C9.77614237,-5.07265313e-17 10,0.223857625 10,0.5 L10,2 Z M9,2 L9,1 L7,1 L7,2 L9,2 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = TrashIcon;

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TriangleDropDownIcon = function TriangleDropDownIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    _extends({}, props, { width: 10, height: 5 }),
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement(
        'g',
        { transform: 'translate(-629.000000, -2970.000000)', fill: '#212D42' },
        _react2.default.createElement('polygon', { points: '629 2970 639 2970 634 2975' })
      )
    )
  );
};

exports.default = TriangleDropDownIcon;

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _BaseIcon = __webpack_require__(9);

var _BaseIcon2 = _interopRequireDefault(_BaseIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UploadIcon = function UploadIcon(props) {
  return _react2.default.createElement(
    _BaseIcon2.default,
    props,
    _react2.default.createElement(
      'g',
      { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { d: 'M7,3.49129842 L5.15079137,5.07633438 C4.73146553,5.43575653 4.10016555,5.387195 3.7407434,4.96786915 C3.38132125,4.54854331 3.42988278,3.91724333 3.84920863,3.55782118 L8,5.34128297e-13 L12.1507914,3.55782118 C12.5701172,3.91724333 12.6186788,4.54854331 12.2592566,4.96786915 C11.8998345,5.387195 11.2685345,5.43575653 10.8492086,5.07633438 L9,3.49129842 L9,10 C9,10.5522847 8.55228475,11 8,11 C7.44771525,11 7,10.5522847 7,10 L7,3.49129842 Z M14,14 L14,9.5 C14,8.94771525 14.4477153,8.5 15,8.5 C15.5522847,8.5 16,8.94771525 16,9.5 L16,16 L0,16 L0,9.5 C0,8.94771525 0.44771525,8.5 1,8.5 C1.55228475,8.5 2,8.94771525 2,9.5 L2,14 L14,14 Z', fillRule: 'nonzero' })
    )
  );
};

exports.default = UploadIcon;

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AddFillableFieldsIcon = __webpack_require__(487);

Object.defineProperty(exports, 'AddFillableFieldsIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddFillableFieldsIcon).default;
  }
});

var _AddRecipientsIcon = __webpack_require__(488);

Object.defineProperty(exports, 'AddRecipientsIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AddRecipientsIcon).default;
  }
});

var _ArrowLeftIcon = __webpack_require__(489);

Object.defineProperty(exports, 'ArrowLeftIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ArrowLeftIcon).default;
  }
});

var _ArrowRightIcon = __webpack_require__(490);

Object.defineProperty(exports, 'ArrowRightIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ArrowRightIcon).default;
  }
});

var _CheckMarkIcon = __webpack_require__(491);

Object.defineProperty(exports, 'CheckMarkIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CheckMarkIcon).default;
  }
});

var _CloseIcon = __webpack_require__(493);

Object.defineProperty(exports, 'CloseIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CloseIcon).default;
  }
});

var _CloseSmallIcon = __webpack_require__(494);

Object.defineProperty(exports, 'CloseSmallIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CloseSmallIcon).default;
  }
});

var _CreateIcon = __webpack_require__(495);

Object.defineProperty(exports, 'CreateIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CreateIcon).default;
  }
});

var _DuplicateIcon = __webpack_require__(496);

Object.defineProperty(exports, 'DuplicateIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DuplicateIcon).default;
  }
});

var _FolderIcon = __webpack_require__(497);

Object.defineProperty(exports, 'FolderIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FolderIcon).default;
  }
});

var _HelpIcon = __webpack_require__(498);

Object.defineProperty(exports, 'HelpIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HelpIcon).default;
  }
});

var _MenuIcon = __webpack_require__(499);

Object.defineProperty(exports, 'MenuIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MenuIcon).default;
  }
});

var _OpenNewIcon = __webpack_require__(500);

Object.defineProperty(exports, 'OpenNewIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OpenNewIcon).default;
  }
});

var _OrganizeTemplateIcon = __webpack_require__(501);

Object.defineProperty(exports, 'OrganizeTemplateIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OrganizeTemplateIcon).default;
  }
});

var _PlayIcon = __webpack_require__(502);

Object.defineProperty(exports, 'PlayIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PlayIcon).default;
  }
});

var _PlusIcon = __webpack_require__(503);

Object.defineProperty(exports, 'PlusIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PlusIcon).default;
  }
});

var _PrepareToSendIcon = __webpack_require__(504);

Object.defineProperty(exports, 'PrepareToSendIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrepareToSendIcon).default;
  }
});

var _PreviewIcon = __webpack_require__(505);

Object.defineProperty(exports, 'PreviewIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PreviewIcon).default;
  }
});

var _PrintIcon = __webpack_require__(506);

Object.defineProperty(exports, 'PrintIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrintIcon).default;
  }
});

var _ReverseIcon = __webpack_require__(507);

Object.defineProperty(exports, 'ReverseIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ReverseIcon).default;
  }
});

var _SearchIcon = __webpack_require__(508);

Object.defineProperty(exports, 'SearchIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchIcon).default;
  }
});

var _SendForSignatureIcon = __webpack_require__(509);

Object.defineProperty(exports, 'SendForSignatureIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SendForSignatureIcon).default;
  }
});

var _ShareIcon = __webpack_require__(510);

Object.defineProperty(exports, 'ShareIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ShareIcon).default;
  }
});

var _SigningDateIcon = __webpack_require__(513);

Object.defineProperty(exports, 'SigningDateIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SigningDateIcon).default;
  }
});

var _SigningSignIcon = __webpack_require__(514);

Object.defineProperty(exports, 'SigningSignIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SigningSignIcon).default;
  }
});

var _SigningTextIcon = __webpack_require__(515);

Object.defineProperty(exports, 'SigningTextIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SigningTextIcon).default;
  }
});

var _SignIcon = __webpack_require__(511);

Object.defineProperty(exports, 'SignIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SignIcon).default;
  }
});

var _SignIllustrationIcon = __webpack_require__(512);

Object.defineProperty(exports, 'SignIllustrationIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SignIllustrationIcon).default;
  }
});

var _TrashIcon = __webpack_require__(516);

Object.defineProperty(exports, 'TrashIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrashIcon).default;
  }
});

var _TriangleDropDownIcon = __webpack_require__(517);

Object.defineProperty(exports, 'TriangleDropDownIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TriangleDropDownIcon).default;
  }
});

var _UploadIcon = __webpack_require__(518);

Object.defineProperty(exports, 'UploadIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_UploadIcon).default;
  }
});

var _ClockIcon = __webpack_require__(492);

Object.defineProperty(exports, 'ClockIcon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ClockIcon).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['lg', 'md', 'sm', 'xs'];

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseIcon = function (_React$PureComponent) {
  _inherits(BaseIcon, _React$PureComponent);

  function BaseIcon() {
    _classCallCheck(this, BaseIcon);

    return _possibleConstructorReturn(this, (BaseIcon.__proto__ || Object.getPrototypeOf(BaseIcon)).apply(this, arguments));
  }

  _createClass(BaseIcon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          height = _props.height,
          width = _props.width,
          viewBox = _props.viewBox,
          scale = _props.scale,
          className = _props.className,
          rest = _objectWithoutProperties(_props, ['children', 'height', 'width', 'viewBox', 'scale', 'className']);

      var viewBoxToUse = viewBox || '0 0 ' + width + ' ' + height;
      var classes = (0, _classnames2.default)('ds-icon', className);
      return _react2.default.createElement(
        'svg',
        _extends({
          height: height + 'px',
          width: width + 'px',
          viewBox: viewBoxToUse,
          style: {
            transform: 'scale(' + scale + ')'
          },
          className: classes
        }, rest),
        children
      );
    }
  }]);

  return BaseIcon;
}(_react2.default.PureComponent);

exports.default = BaseIcon;


BaseIcon.defaultProps = {
  children: null,
  className: 'ds-icon-inherit-color',
  height: 16,
  onClick: function onClick() {},
  scale: 1,
  viewBox: '',
  width: 16
};

BaseIcon.propTypes = {
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  height: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  scale: _propTypes2.default.number,
  viewBox: _propTypes2.default.string,
  width: _propTypes2.default.number
};

/***/ })

},[464]);


// WEBPACK FOOTER //
// seo-head-term-state-navbar-mobile.js